module.exports = __webpack_public_path__ + "img/food_audio.8e8dd44b.jpg";